import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import Ingredient from './ingredient';
import MealItem from './meal-item';
import MealItemAssignment from './meal-item-assignment';
import MealItemAssignmentIngredient from './meal-item-assignment-ingredient';
import Measure from './measure';

@JsonApiResource({
  type: 'meal-item-ingredient',
})
export default class MealItemIngredient extends BaseEntity {
  @JsonApiProperty({ resolver: Number }) public sortOrder: number = 127;
  @JsonApiProperty({ resolver: Number }) units: number = 1.0;
  @JsonApiRelationship('ingredient') ingredient: Ingredient;
  @JsonApiRelationship('meal-item') mealItem: MealItem;
  @JsonApiRelationship('measure') measure: Measure;

  @JsonApiProperty({ type: 'object', readOnly: true })
  public toMealItemAssignmentIngredient(
    mealItemAssignment: MealItemAssignment
  ): MealItemAssignmentIngredient {
    return new MealItemAssignmentIngredient(
      this.id,
      this.ingredient,
      this.units,
      this.measure,
      mealItemAssignment,
      this.units,
      this.sortOrder
    );
  }

  @JsonApiProperty({ type: 'object', readOnly: true })
  public get isPrimary(): boolean {
    return this.sortOrder === 0;
  }

  constructor(
    id?: MealItemIngredient['id'],
    ingredient: MealItemIngredient['ingredient'] = new Ingredient(),
    units: MealItemIngredient['units'] = 1.0,
    measure: MealItemIngredient['measure'] = new Measure('1'),
    mealItem: MealItemIngredient['mealItem'] = new MealItem(),
    sortOrder: MealItemIngredient['sortOrder'] = 127
  ) {
    super();
    this.id = id;
    this.ingredient = ingredient;
    this.units = units;
    this.mealItem = mealItem;
    this.measure = measure;
    this.sortOrder = sortOrder;
  }
}
